import { RowDataPacket } from "mysql2";
import { SUREPARKSubscriber } from "../../shared/types";

// Magic dates used for billing status
// When an invoice is first created and queued for billing, it is set to this date
export const BILLING_PENDING_DATE = '1970-01-01 00:00:00';
// On the NG-RPC portal we don't allow null last_billed dates so when an invoice is first created it is set to this date.
// We set it to this date so we know that it was never billed.
export const BILLING_NEVER_BILLED_DATE = '1972-02-02 00:00:00';
  export interface MonthlyInvoice extends RowDataPacket {
    lid?: number;
    suite: number;
    account: number;
    amt: string;
    data: string;
    last_billed: string;
    next_billed: string | null;
    tenant?:string;
    groupId?:string;
    tenant_status: string;
    bill_status: string;
    ver: number;
    last_refreshed: string;
    bill_status_reason: string;
    tenant_name: string;
    issue_description?: string;
    company: string;
    uniqueId?: string;  // Added for table row selection
  }

  export interface ChangeBillStatusRequest {
    status: string,
    suite: string,
    account: string,
    reason?: string,
    deactiveKeycards?: boolean
  }

  export interface ChangeBillStatusRequestWithKeycardAction extends ChangeBillStatusRequest{
    action?: string,
    facility_code?: string,
    keycard?: string
  }

export type InvoiceProcessingStatus = 'pending' | 'processing' | 'completed' | 'error';

export interface ProcessMonthlyInvoiceOneByOneRequest {
  invoices: Array<{
    suite: number;
    account: number;
  }>;
  month?: number;
  year?: number;
  dryRun?: boolean;
}

export interface InvoiceProcessingResult {
  suite: number;
  account: number;
  status: InvoiceProcessingStatus;
  error?: string;
  invoiceId?: number;
}